// extracted by mini-css-extract-plugin
export default {"menu":"VerticalMenuSection_menu__IjsLF","selectedClass":"VerticalMenuSection_selectedClass__U2Ezm"};